var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "white",
    fill: "none",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 7.66911V11.6691C11 12.0227 10.8595 12.3619 10.6095 12.6119C10.3594 12.862 10.0203 13.0024 9.66667 13.0024H2.33333C1.97971 13.0024 1.64057 12.862 1.39052 12.6119C1.14048 12.3619 1 12.0227 1 11.6691V4.33577C1 3.98215 1.14048 3.64301 1.39052 3.39297C1.64057 3.14292 1.97971 3.00244 2.33333 3.00244H6.33333M9 1.00244H13V5.00244M5.66675 8.33577L13.0001 1.00244",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.174fabe91acae6626dfe00aa51f19e23.svg";
export { ForwardRef as ReactComponent };